<template>
  <div class="tv">
    <header class="tv-kopf">
      <div class="tv-lokal">
        <img v-if="lokalLogo" class="tv-lokal__logo" :src="lokalLogo" :alt="lokal" />
        <div v-else-if="lokal" class="tv-lokal__name">{{ lokal }}</div>
        <div v-else class="tv-logo">team-match.io</div>
      </div>
      <div class="tv-mitte">
        <div v-if="badgeText" class="tv-runde"><span v-if="anzahlLaufend > 0" class="tv-punkt"></span>{{ badgeText }}</div>
      </div>
      <div class="tv-rechts">
        <div v-if="qr && !(!zeilen.length && countdown)" class="tv-qr tv-qr--kopf">
          <svg :viewBox="`0 0 ${qr.size} ${qr.size}`" shape-rendering="crispEdges" role="img" :aria-label="qrText"><rect width="100%" height="100%" fill="#fff" /><path :d="qr.d" fill="#000" /></svg>
          <span>{{ qrText }}</span>
        </div>
        <div class="tv-titel"><b v-if="titel">{{ titel }}</b><span>{{ rundenTitel }}</span></div>
        <div class="tv-uhr">
          <div class="tv-uhr__zeit">{{ uhrText }}</div>
          <div v-if="abgeschlossen" class="tv-uhr__lokal">Endstand<template v-if="endstandText"> · {{ endstandText }}</template></div>
          <div v-else class="tv-uhr__lokal"><span :class="['tv-verbindung', { aus: !verbunden }]"></span>{{ verbunden ? 'Verbunden' : 'Keine Verbindung' }}<template v-if="standText"> · Stand {{ standText }}</template></div>
        </div>
      </div>
    </header>

    <main class="tv-haupt">
      <div class="tv-links">
      <section class="tv-rang">
        <div class="tv-rang__titel">
          Rangliste<template v-if="zeilen.length"> · Top {{ zeilen.length }}</template>
        </div>
        <div v-if="zeilen.length" :class="['tv-rang__spalten', { 'ohne-heute': !zeigeHeute, 'ohne-bew': !zeigeBewegung }]">
          <span>Platz</span><span v-if="zeigeBewegung">Bewegung</span><span>Name</span><span v-if="zeigeHeute" class="r">Heute</span><span class="r">Punkte</span>
        </div>

        <div v-if="!zeilen.length && countdown" class="tv-countdown">
          <div class="tv-countdown__label">Die Runde startet in</div>
          <div class="tv-countdown__zahl">{{ countdown.zahl }}</div>
          <div class="tv-countdown__sub">{{ countdown.sub }}</div>
          <div v-if="qr" class="tv-qr tv-qr--gross">
            <svg :viewBox="`0 0 ${qr.size} ${qr.size}`" shape-rendering="crispEdges" role="img" :aria-label="qrText"><rect width="100%" height="100%" fill="#fff" /><path :d="qr.d" fill="#000" /></svg>
            <span>{{ qrText }}</span>
          </div>
        </div>
        <div v-else-if="!zeilen.length" class="tv-leer">{{ leerText }}</div>

        <div class="tv-rang__liste" v-auto-animate>
          <div v-for="z in zeilen" :key="z.id" :class="['tv-zeile', { 'ohne-heute': !zeigeHeute, 'ohne-bew': !zeigeBewegung }]">
            <span class="tv-platz">{{ z.rang }}</span>
            <span v-if="zeigeBewegung" :class="['tv-bew', z.bewegung > 0 ? 'auf' : z.bewegung < 0 ? 'ab' : '']">
              <template v-if="z.bewegung > 0">▲ {{ z.bewegung }}</template>
              <template v-else-if="z.bewegung < 0">▼ {{ -z.bewegung }}</template>
              <template v-else>–</template>
            </span>
            <span class="tv-name"><span class="tv-balken" :style="{ width: Math.max(2, z.anteil * 100) + '%' }"></span>
              {{ z.name }}
              <span v-if="z.geteilt" class="tv-geteilt">geteilt</span>
            </span>
            <span v-if="zeigeHeute" :class="['tv-heute r', z.heute > 0.005 ? 'plus' : '']">{{ fmtHeute(z.heute) }}</span>
            <span class="tv-punkte r">{{ fmt(z.punkte) }}</span>
          </div>
        </div>
      </section>
      </div>

      <aside class="tv-spiele">
        <div class="tv-spiele__titel">Spiele</div>
        <div v-if="!spieleGesamt" class="tv-leer">Gerade keine Spiele.</div>
        <div :class="['tv-spiele__liste', { zweispaltig: spieleGesamt > 9 }]">
          <template v-for="g in gruppen" :key="g.titel">
            <div v-if="g.liste.length" class="tv-grp">{{ g.titel }} · {{ g.liste.length }}</div>
            <div v-for="s in g.liste" :key="s.id" :class="['tv-spiel', { fertig: g.fertig, 'hat-tor': torSeite(s) !== null }]">
              <div class="tv-spiel__zeit">{{ g.fertig ? endeText(s) : g.gleich ? anstossText(s) : spielZeit(s) }}<span v-if="torSeite(s) !== null" class="tv-tor-pille">TOR</span></div>
              <div :class="['tv-seite heim', { tor: torSeite(s) === 0 }]"><span class="tv-spiel__name">{{ s.heim }}</span><img v-if="logo(s, 0)" class="tv-logo-team" :src="logo(s, 0)" alt="" /><span v-else class="tv-logo-team tv-logo-team--ersatz">{{ ersatz(s.heim) }}</span></div>
              <div class="tv-erg"><template v-if="g.gleich"><i>–</i></template><template v-else><b :class="{ tor: torSeite(s) === 0 }">{{ s.heimtore ?? '–' }}</b><i>:</i><b :class="{ tor: torSeite(s) === 1 }">{{ s.austore ?? '–' }}</b></template></div>
              <div :class="['tv-seite gast', { tor: torSeite(s) === 1 }]"><img v-if="logo(s, 1)" class="tv-logo-team" :src="logo(s, 1)" alt="" /><span v-else class="tv-logo-team tv-logo-team--ersatz">{{ ersatz(s.auswaerts) }}</span><span class="tv-spiel__name">{{ s.auswaerts }}</span></div>
            </div>
          </template>
        </div>
      </aside>
    </main>

    <footer class="tv-fuss">
      <span class="tv-ticker__marke">{{ abgeschlossen ? 'LETZTE TORE' : 'TICKER' }}</span>
      <div ref="tickerFenster" class="tv-ticker__fenster">
        <div :class="['tv-ticker__bahn', { lauf: tickerLauf }]" :style="tickerLauf ? { animationDuration: tickerDauer + 's' } : null">
          <span ref="tickerText1" class="tv-ticker__text">{{ tickerText }}</span><span v-if="tickerLauf" class="tv-ticker__text" aria-hidden="true">{{ tickerText }}</span>
        </div>
      </div>
    </footer>
    <div v-if="sponsorListe.length" class="tv-sponsorleiste">
      <div v-for="(u, i) in sponsorListe" :key="i" class="tv-sponsor"><img :src="u" alt="" /></div>
    </div>
  </div>
</template>

<script>
// Modul-Ebene: bleibt erhalten, auch wenn die Komponente neu gemountet wird (Hot-Reload, Tab-Wechsel).
// Der Server schickt die Logos (matches[].json) offenbar nur beim Verbindungsaufbau; ohne diesen Speicher gehen sie dann verloren.
import { reactive as reaktiv } from 'vue'
const logoCache = reaktiv({})
function lerneLogos(ev) {
  for (const m of ev?.detail?.matches ?? []) {
    try {
      const j = typeof m.json === 'string' ? JSON.parse(m.json) : m.json
      const eintrag = { heim: j?.home?.logo ?? null, ausw: j?.away?.logo ?? null }
      if (!eintrag.heim && !eintrag.ausw) continue
      if (m.id != null) logoCache[String(m.id)] = eintrag
      if (m.oddsId != null) logoCache[String(m.oddsId)] = eintrag
    } catch (e) { /* kaputtes json ignorieren */ }
  }
}
if (typeof window !== 'undefined' && !window.__tmTvLogosAktiv) {
  window.__tmTvLogosAktiv = true
  window.addEventListener('tm-live-scores', lerneLogos)
}
</script>

<script setup>
// TV-Ansicht, Schritt 1: Rangliste (Gesamt + "Heute" aus der Runde), laufende Spiele, Ticker.
// Nur lesend. Nutzt useLiveScores unverändert. Mit demo=true laufen Fake-Daten ohne Socket.
// Noch nicht enthalten: Tor-Vollbild (Schritt 2), Endstand/Podium (Schritt 3), Hinweiszeilen (Stufe 2).
import { ref, reactive, computed, watch, nextTick, onMounted, onUnmounted } from 'vue'
import { vAutoAnimate } from '@formkit/auto-animate/vue'
import { useLiveScores } from '../composables/useLiveScores.js'
import { vergleicheRang } from '../composables/rangSortierung.js'
import qrcode from 'qrcode-generator'
import { toreAusEvents } from '../composables/matchEvents.js'

const props = defineProps({
  wsUrl: { type: String, default: '' },
  roundId: { type: [Number, String], default: 0 },
  rundenName: { type: String, default: '' },
  lokal: { type: String, default: '' },
  anzahl: { type: Number, default: 10 },
  // Logo des Lokals (URL) für oben links; ohne Logo steht der Lokalname fett dort
  lokalLogo: { type: String, default: '' },
  // Titel rechts oben, z. B. "Irish-Pub-Tippspiel"
  titel: { type: String, default: '' },
  // Sponsorenleiste unter der Rangliste: Logo-URLs, komma-getrennt (max. 7)
  sponsoren: { type: String, default: '' },
  // QR-Code (z. B. Anmelde-Link des Lokals) oben rechts und groß vor Rundenstart; leer = kein Code
  qrUrl: { type: String, default: '' },
  qrText: { type: String, default: 'Mitspielen' },
  demo: { type: Boolean, default: false },
  // 'runde' = Platz und Punkte aus der Rundenwertung (wie die App), 'gesamt' = Gesamtliga plus Spalte "Heute"
  modus: { type: String, default: 'runde' },
  // Komma-getrennte Spiel-IDs der Runde (idDB, z. B. "277331,418013"). Leer = alle Spiele zeigen.
  matchIds: { type: String, default: '' },
  // Wie in RundenRanking.vue: Fallback per REST, falls der Socket für die Runde nichts liefert
  apiBase: { type: String, default: '' },
  companyId: { type: [Number, String], default: 0 },
})

const leer = {
  verbinden: () => {}, aufraeumen: () => {}, meldeRunde: () => {},
  rankingsProRunde: {}, rankingGesamt: ref([]), tickerEintraege: ref([]), liveSpiele: {},
  aenderungenProRunde: {},
}
const live = (!props.demo && props.wsUrl) ? useLiveScores(props.wsUrl, ref([])) : leer
const { verbinden, aufraeumen, meldeRunde, rankingsProRunde, rankingGesamt, tickerEintraege, liveSpiele, aenderungenProRunde } = live

// ---------- Demo-Daten (erfunden) ----------
const demoNamen = ['Mia K.', 'Jonas P.', 'Lena S.', 'Tobias R.', 'Emre D.', 'Clara W.', 'Paul H.', 'Sophie M.', 'Daniel F.', 'Nina B.', 'Max L.', 'Eva T.']
const demoGesamt = demoNamen.map((name, i) => ({
  id: i + 1, name, rang: [1, 2, 3, 4, 5, 5, 7, 8, 9, 10, 11, 12][i],
  punkte: [118.4, 116.95, 115.6, 112.35, 109.8, 109.8, 107.25, 106.1, 104.9, 103.55, 101.2, 99.8][i],
  heute: [6.2, 3.1, 4.8, 0, 2.4, 1.1, 5.6, 0, 1.9, 0, 0, 0][i],
  vorher: [3, 1, 6, 2, 4, 5, 10, 7, 8, 9, 11, 12][i],
}))
const demoSpiele = [
  { id: 'd1', heim: 'Atalanta', auswaerts: 'Frosinone', heimtore: 1, austore: 0, minute: 74, extra: 0, kurz: '2H' },
  { id: 'd2', heim: 'Lyon', auswaerts: 'Nizza', heimtore: 2, austore: 2, minute: 61, extra: 0, kurz: '2H' },
  { id: 'd3', heim: 'Sevilla', auswaerts: 'Valencia', heimtore: 0, austore: 1, minute: 38, extra: 0, kurz: '1H' },
]

// ---------- Namen ----------
// Gesichert (aus useLiveScores): rounds-live wird am ersten Leerzeichen gesplittet, die Quelle heißt
// "S***** Dieter" -> firstname = "S*****", lastname = "Dieter". Dort ist der Vorname also im Feld lastname.
// rankings (Gesamt) hat firstname/lastname in der richtigen Reihenfolge.
const schoen = (s) => String(s ?? '').trim().toLowerCase().replace(/(^|[-\s])(\p{L})/gu, (m, a, b) => a + b.toUpperCase())
function kurzName(vorname, nachnameGekuerzt) {
  const v = schoen(vorname)
  const ini = String(nachnameGekuerzt ?? '').trim().charAt(0).toUpperCase()
  return ini ? `${v} ${ini}.` : v
}

// ---------- Rangliste ----------
// Feste round-id (Attribut) hat Vorrang. Ohne round-id fragt das Widget den Server, welche Runde der Manager für dieses Lokal gewählt hat.
const tvRunde = ref(0)
const tvRundeName = ref('')
const rid = computed(() => Number(props.roundId) > 0 ? Number(props.roundId) : tvRunde.value)
async function ladeTvRunde() {
  if (props.demo || Number(props.roundId) > 0 || !props.apiBase || !props.lokal) return
  try {
    const r = await fetch(`${props.apiBase}/tv/${encodeURIComponent(props.lokal)}/runde`, { cache: 'no-store' })
    if (!r.ok) return                                   // Fehler: bisherige Runde bleibt stehen
    const d = await r.json()
    const neu = Number(d?.roundId) || 0
    if (neu > 0) { tvRunde.value = neu; tvRundeName.value = d?.name ?? '' }
  } catch (e) { /* nächster Versuch kommt */ }
}
let tvTimer = null

// REST-Fallback (gleicher Aufruf wie ladenPerRest in RundenRanking.vue)
const restEintraege = ref([])
const restSpiele = ref([])           // Feld spiele (Server, optional): alle Spiele der Runde inkl. beendet / noch nicht gestartet
const abgeschlossen = ref(false)
const restStand = ref(0)            // Zeitpunkt des Endstands (REST: stand, Millisekunden)
const restMatchIds = ref([])        // Spiele der Runde laut REST (Feld matchIds, API-Ids als Text)
let matchIdsGeprueft = false
// Rang davor je Spieler laut REST (der Socket liefert in rounds-live kein rankingPrevious)
const restVorher = computed(() => new Map(restEintraege.value.map(e => [e.registrationID, e.rankingPrevious || 0])))
let restTimer = null
async function ladenPerRest() {
  if (props.demo || !props.apiBase || rid.value <= 0) return
  const socketHat = (rankingsProRunde[rid.value] ?? []).length > 0
  // Ranking vom Socket und Spielliste schon geholt: nur noch nachfragen, solange Spiele laufen (für rankingPrevious)
  if (socketHat && matchIdsGeprueft && anzahlLaufend.value === 0 && restSpiele.value.length > 0 && !restSpiele.value.some(x => !x.completed)) return
  try {
    const r = await fetch(`${props.apiBase}/${rid.value}/ranking?companyID=${props.companyId}`)
    if (!r.ok) return
    const d = await r.json()
    matchIdsGeprueft = true
    if (Array.isArray(d?.matchIds)) restMatchIds.value = d.matchIds.map(String)
    if (Array.isArray(d?.spiele)) restSpiele.value = d.spiele
    abgeschlossen.value = !!d?.abgeschlossen
    restStand.value = Number(d?.stand) || 0
    restEintraege.value = Array.isArray(d?.rankingsLive) ? d.rankingsLive : []
  } catch (e) { /* nächster Versuch kommt */ }
}

const gesamtListe = computed(() => {
  if (props.demo) return demoGesamt.map(d => ({ ...d, previous: d.vorher }))
  if (props.modus === 'runde') {
    // Gleiche Quelle wie RundenRanking.vue: rankingsProRunde[roundId], Punkte = result der Runde
    const live = rankingsProRunde[rid.value]
    const vomSocket = !!live?.length
    const quelle = vomSocket ? live : restEintraege.value
    return quelle.map(e => ({
      // Socket liefert Vor- und Nachname vertauscht (Split am Leerzeichen), REST in richtiger Reihenfolge
      id: e.registrationID, name: vomSocket ? kurzName(e.lastname, e.firstname) : kurzName(e.firstname, e.lastname),
      rang: e.ranking, punkte: Number(e.value) || 0,
      previous: (vomSocket ? restVorher.value.get(e.registrationID) : null) || e.rankingPrevious || 0,
    }))
  }
  const ausRunde = rankingsProRunde[-1]
  if (ausRunde?.length) {
    return ausRunde.map(e => ({
      id: e.registrationID, name: kurzName(e.lastname, e.firstname),
      rang: e.ranking, punkte: Number(e.value) || 0, previous: e.rankingPrevious || 0,
    }))
  }
  return (rankingGesamt.value ?? []).map(e => ({
    id: e.registrationID, name: kurzName(e.firstname, e.lastname),
    rang: e.ranking, punkte: Number(e.value) || 0, previous: e.rankingPrevious || 0,
  }))
})

const heuteMap = computed(() => {
  const m = new Map()
  if (props.demo) { demoGesamt.forEach(d => m.set(d.id, d.heute)); return m }
  for (const e of rankingsProRunde[rid.value] ?? []) m.set(e.registrationID, Number(e.value) || 0)
  return m
})

// Bewegung: Server-Wert (rankingPrevious), falls vorhanden; sonst Wechsel seit dem Öffnen dieser Seite.
const rangMerker = {}
const vorherRang = reactive({})
watch(gesamtListe, (liste) => {
  for (const e of liste) {
    const alt = rangMerker[e.id]
    if (alt === undefined) rangMerker[e.id] = e.rang
    else if (alt !== e.rang) { vorherRang[e.id] = alt; rangMerker[e.id] = e.rang }
  }
}, { immediate: true })

const zeilen = computed(() => {
  // Gleiche Sortierung wie die App (Punkte mit Toleranz, dann Serverrang; bei Gleichstand bleibt die Serverreihenfolge)
  const liste = [...gesamtListe.value].sort((a, b) =>
    vergleicheRang({ value: a.punkte, ranking: a.rang }, { value: b.punkte, ranking: b.rang }))
  const zaehler = new Map()
  for (const e of liste) zaehler.set(e.rang, (zaehler.get(e.rang) ?? 0) + 1)
  const sichtbar = liste.slice(0, props.anzahl)
  const maxPunkte = sichtbar[0]?.punkte || 0
  const minPunkte = sichtbar.length ? sichtbar[sichtbar.length - 1].punkte : 0
  const spanne = maxPunkte - minPunkte
  return liste.slice(0, props.anzahl).map(e => {
    // Rang davor, in dieser Reihenfolge: (1) aenderungen vom Server (überlebt ein Neuladen, wie in der App),
    // (2) Wechsel seit dem Öffnen der Seite, (3) rankingPrevious aus REST.
    // aenderungen wie in der App: rangAlt gegen den aktuellen Rang (auch wenn nur andere Spieler Punkte geholt haben).
    const a = props.modus === 'runde' ? aenderungenProRunde?.[`${rid.value}_${e.id}`] : null
    const ausAenderung = (a && a.rangAlt > 0) ? a.rangAlt : null
    const alt = ausAenderung ?? vorherRang[e.id] ?? (e.previous > 0 ? e.previous : null)
    return {
      id: e.id, name: e.name, rang: e.rang, punkte: e.punkte,
      heute: heuteMap.value.get(e.id) ?? 0,
      geteilt: zaehler.get(e.rang) > 1,
      bewegung: alt == null ? 0 : alt - e.rang,
      anteil: spanne > 0 ? 0.38 + 0.62 * (Math.max(0, e.punkte) - minPunkte) / spanne : 1,
    }
  })
})
// Im Endstand gibt es keine Bewegung mehr (Rang davor = Rang jetzt), die Spalte entfällt
const zeigeBewegung = computed(() => !abgeschlossen.value)
const zeigeHeute = computed(() => props.demo || props.modus === 'gesamt')

// ---------- Spiele der Runde ----------
// Quelle: REST-Feld matchIds (Server). Ohne Liste werden alle Spiele gezeigt.

const fmt = (x) => Number(x ?? 0).toLocaleString('de-AT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const fmtHeute = (x) => (x > 0.005 ? '+' : '') + fmt(x)

// ---------- Laufende Spiele ----------
const NICHT_LIVE = new Set(['NS', 'TBD', 'PST', 'CANC', 'ABD', 'AWD', 'WO', 'FT', 'AET', 'PEN'])
const istLaufend = (s) => !s.completed && !NICHT_LIVE.has(s.kurz) && (s.kurz != null || s.minute > 0)
const idMenge = computed(() => {
  const fest = new Set(String(props.matchIds ?? '').split(',').map(x => x.trim()).filter(Boolean))
  if (fest.size) return fest                                              // optionales Attribut hat Vorrang
  if (restMatchIds.value.length) {                                         // Spiele der Runde vom Server (REST)
    // plus die DB-Ids aus spiele: Ticker-Einträge aus dem Socket tragen nur die DB-Id (useLiveScores verwirft oddsId)
    const menge = new Set(restMatchIds.value)
    for (const x of restSpiele.value) { if (x.id != null) menge.add(String(x.id)); if (x.oddsId != null) menge.add(String(x.oddsId)) }
    return menge
  }
  return new Set()                                                         // sonst: alle Spiele
})
// Ohne Liste: alle. Mit Liste: nur Spiele der Runde (idDB oder API-Id)
const inRunde = (id, apiId) => idMenge.value.size === 0 || idMenge.value.has(String(id)) || (apiId != null && idMenge.value.has(String(apiId)))
// Spiele aus dem Socket (liveSpiele, Schlüssel idDB) und aus REST (spiele, optional) zusammenführen, Schlüssel = API-Id.
// Regel: Socket gewinnt, außer REST meldet das Spiel als beendet (der Socket kann einen alten Live-Stand behalten).
const ENDE = new Set(['FT', 'AET', 'PEN'])
// Ältere Form des Server-Blocks: results / json als Text. Daraus nur das Nötige lesen (neue Form liefert die Felder direkt).
function leseErgebnis(x) {
  const leer = { heimtore: null, austore: null, status: null, minute: null, extra: null, heimLogo: null, gastLogo: null, events: null, heimId: null }
  try {
    const r = typeof x.results === 'string' ? JSON.parse(x.results) : x.results
    if (r?.scores?.hasScores) {
      for (const t of r.scores.scores ?? []) {
        const n = Number.parseInt(t.score, 10)
        if (t.name === x.heim) leer.heimtore = Number.isFinite(n) ? n : null
        if (t.name === x.gast) leer.austore = Number.isFinite(n) ? n : null
      }
    }
    leer.status = r?.status?.shortS ?? null
    leer.minute = r?.status?.elapsed ?? null
    leer.extra = r?.status?.extra ?? null
    leer.heimLogo = r?.matchJson?.home?.logo ?? null
    leer.gastLogo = r?.matchJson?.away?.logo ?? null
    leer.events = r?.events ?? null
    leer.heimId = r?.matchJson?.home?.id ?? null
  } catch (e) { /* ignorieren */ }
  try {
    if (!leer.heimLogo || !leer.gastLogo) {
      const j = typeof x.json === 'string' ? JSON.parse(x.json) : x.json
      leer.heimLogo = leer.heimLogo ?? j?.home?.logo ?? null
      leer.gastLogo = leer.gastLogo ?? j?.away?.logo ?? null
    }
  } catch (e) { /* ignorieren */ }
  return leer
}
const alleSpiele = computed(() => {
  if (props.demo) return demoSpiele
  const karte = new Map()
  for (const x of restSpiele.value) {
    const api = String(x.oddsId ?? x.id)
    const e = leseErgebnis(x)
    karte.set(api, {
      id: String(x.id ?? api), matchid: api, heim: x.heim, auswaerts: x.gast,
      heimtore: x.heimtore ?? e.heimtore, austore: x.austore ?? e.austore,
      kurz: x.status ?? e.status ?? (x.completed ? 'FT' : 'NS'), minute: x.minute ?? e.minute, extra: x.extra ?? e.extra,
      completed: !!x.completed, anstoss: x.time ?? null,
      heimLogo: x.heimLogo ?? e.heimLogo, gastLogo: x.gastLogo ?? e.gastLogo,
    })
  }
  for (const [id, sp] of Object.entries(liveSpiele ?? {})) {
    if (!inRunde(id, sp.matchid)) continue
    const api = String(sp.matchid ?? id)
    const rest = karte.get(api)
    if (rest?.completed) { rest.id = String(id); continue }
    karte.set(api, { ...(rest ?? {}), id: String(id), matchid: api, ...sp, anstoss: rest?.anstoss ?? null })
  }
  return [...karte.values()]
})
const istBeendet = (s) => !!s.completed || ENDE.has(s.kurz)
const istGleich = (s) => !istBeendet(s) && (s.kurz === 'NS' || s.kurz === 'TBD') && !(s.minute > 0)
// Feste Reihenfolge (Anstoß, dann Id), damit nichts springt; Tore werden nur hervorgehoben
const nachAnstoss = (a, b) => (zeitMs(a.anstoss) - zeitMs(b.anstoss)) || String(a.id).localeCompare(String(b.id), 'de', { numeric: true })
const zeitMs = (t) => { const d = new Date(t ?? 0).getTime(); return Number.isFinite(d) ? d : 0 }
const laufend = computed(() => alleSpiele.value.filter(s => !istBeendet(s) && !istGleich(s) && istLaufend(s)).sort(nachAnstoss))
const gleich = computed(() => alleSpiele.value.filter(istGleich).sort(nachAnstoss))
const beendet = computed(() => alleSpiele.value.filter(istBeendet).sort(nachAnstoss))
const gruppen = computed(() => [
  { titel: 'Läuft', liste: laufend.value, fertig: false, gleich: false },
  { titel: 'Gleich', liste: gleich.value, fertig: false, gleich: true },
  { titel: 'Beendet', liste: beendet.value, fertig: true, gleich: false },
])
const spieleGesamt = computed(() => laufend.value.length + gleich.value.length + beendet.value.length)
// Text, solange die Rangliste noch leer ist
const leerText = computed(() => {
  if (abgeschlossen.value) return 'Kein Ranking vorhanden'
  const erster = gleich.value[0]
  if (erster && anstossText(erster)) return `Die Runde startet um ${anstossText(erster)} Uhr`
  return 'Warte auf Daten …'
})
// Countdown bis zum ersten Anstoß, solange noch kein Ranking da ist (nutzt die Sekunden-Uhr `jetzt`)
const countdown = computed(() => {
  const erster = gleich.value[0]
  const t = erster ? zeitMs(erster.anstoss) : 0
  const rest = t - jetzt.value
  if (!t || rest <= 0 || abgeschlossen.value) return null
  const z2 = (n) => String(n).padStart(2, '0')
  const tage = Math.floor(rest / 86400000), h = Math.floor(rest % 86400000 / 3600000), m = Math.floor(rest % 3600000 / 60000), sek = Math.floor(rest % 60000 / 1000)
  const zahl = (tage > 0 ? `${tage} ${tage === 1 ? 'Tag' : 'Tage'} ` : '') + `${z2(h)}:${z2(m)}:${z2(sek)}`
  const d = new Date(t), heute = new Date(jetzt.value).toDateString() === d.toDateString()
  const sub = `Anstoß ${heute ? '' : d.toLocaleDateString('de-AT', { weekday: 'short', day: '2-digit', month: '2-digit' }) + ', '}${anstossText(erster)} Uhr`
  return { zahl, sub }
})
const anstossText = (s) => { const t = zeitMs(s.anstoss); return t ? new Date(t).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' }) : '' }
// Beendete Spiele: nach Verlängerung / Elfmeterschießen entsprechend beschriften (Status aus dem Server: ET, AET, PEN)
const endeText = (s) => s.kurz === 'PEN' ? 'n.E.' : (s.kurz === 'AET' || s.kurz === 'ET') ? 'n.V.' : 'Ende'
const anzahlLaufend = computed(() => laufend.value.length)

// Tor-Hervorhebung: Torstand merken; ändert er sich, leuchtet die Mannschaft TOR_DAUER lang
const TOR_DAUER = 90000
const torStand = {}
const torMerker = reactive({})
watch(alleSpiele, (liste) => {
  for (const s of liste) {
    const alt = torStand[s.id]
    const h = s.heimtore ?? 0, a = s.austore ?? 0
    if (alt && (h > alt.h || a > alt.a)) torMerker[s.id] = { seite: h > alt.h ? 0 : 1, bis: Date.now() + TOR_DAUER }
    torStand[s.id] = { h, a }
  }
}, { immediate: true, deep: true })
// 0 = Heim, 1 = Gast, null = kein frisches Tor
const torSeite = (s) => {
  const t = torMerker[s.id]
  return t && t.bis > jetzt.value ? t.seite : null
}

// Logos: der Socket schickt sie in matches[].json (Text mit home.logo / away.logo). useLiveScores speichert sie nicht,
// deshalb hören wir auf das Fenster-Ereignis, das es bei jeder Nachricht auslöst.
const logos = logoCache
const ersatz = (name) => (String(name ?? '').match(/\p{L}/u)?.[0] ?? '?').toUpperCase()   // erster Buchstabe, Ziffern wie bei "1. FC" überspringen
const logo = (s, seite) => {
  const direkt = seite === 0 ? s.heimLogo : s.gastLogo
  if (direkt) return direkt
  const l = logos[String(s.id)] ?? logos[String(s.matchid)]
  return l ? (seite === 0 ? l.heim : l.ausw) : null
}

function spielZeit(s) {
  switch (s.kurz) {
    case 'HT': return 'Halbzeit'
    case 'BT': return 'Pause'
    case 'P': return 'Elfmeter'
    case 'INT': case 'SUSP': return 'Unterbrochen'
  }
  if (s.minute == null || s.minute < 0) return 'LIVE'
  return `${s.minute}${s.extra > 0 ? '+' + s.extra : ''}'`
}

// ---------- Ticker ----------
// Quelle 1: Socket (tickerEintraege, live). Quelle 2: REST spiele[].tore (Reihenfolge der Tore, auch nach Neuladen).
// Aus tore[] ({ minute, extra, seite: 'heim' | 'gast', spieler, art: 'elfmeter' | 'eigentor' | null }) wird der laufende Stand mitgerechnet.
const TICKER_ANZAHL = 30   // alle Tore (neueste zuerst); passt es nicht in die Zeile, läuft der Text durch
const restTicker = computed(() => {
  const aus = []
  for (const x of restSpiele.value) {
    // Reihenfolge der Quellen: kompakte Torliste, gefilterte Events (goals + heimTeamId), Roh-results (ältere Form)
    let liste = Array.isArray(x.tore) ? x.tore : null
    if (!liste) {
      const e = leseErgebnis(x)
      liste = toreAusEvents(x.goals ?? e.events, x.heimTeamId ?? e.heimId)
    }
    if (!liste.length) continue
    const basis = zeitMs(x.time)
    let h = 0, a = 0
    for (const t of [...liste].sort((p, q) => ((p.minute ?? 0) + (p.extra ?? 0) / 100) - ((q.minute ?? 0) + (q.extra ?? 0) / 100))) {
      if (t.seite === 'gast') a++; else h++
      aus.push({ zeit: basis + (t.minute ?? 0) * 60000 + (t.extra ?? 0) * 1000, matchId: x.id, oddsId: x.oddsId, heim: x.heim, auswaerts: x.gast, heimtore: h, austore: a, minute: t.minute, extra: t.extra, spieler: t.spieler ?? null, art: t.art ?? null })
    }
  }
  return aus
})
const tickerText = computed(() => {
  if (props.demo) return "74' Tor Atalanta · Mia K. holt Platz 1 · Lena S. steigt auf Platz 3"
  const socket = (tickerEintraege.value ?? []).filter(t => inRunde(t.matchId, t.oddsId ?? liveSpiele?.[t.matchId]?.matchid))
  // Fehlt im Socket-Eintrag der Schütze, aus REST (spiele[].tore) ergänzen: gleiches Spiel, gleicher Spielstand
  const rest = new Map()
  for (const t of restTicker.value) rest.set(`${t.matchId}|${t.heimtore}:${t.austore}`, t)   // Schlüssel: DB-Id des Spiels + Stand
  const angereichert = socket.map(t => {
    if (t.spieler) return t
    const g = rest.get(`${t.matchId}|${t.heimtore}:${t.austore}`)
    return g?.spieler ? { ...t, spieler: g.spieler, art: g.art } : t
  })
  // Tore, die der Socket nicht (mehr) kennt, kommen aus REST dazu: gleiche Regel (Spiel + Spielstand)
  const imSocket = new Set(angereichert.map(t => `${t.matchId}|${t.heimtore}:${t.austore}`))
  const quelle = [...angereichert, ...restTicker.value.filter(t => !imSocket.has(`${t.matchId}|${t.heimtore}:${t.austore}`))]
  const e = [...quelle].sort((p, q) => (q.zeit ?? 0) - (p.zeit ?? 0)).slice(0, TICKER_ANZAHL)
  if (!e.length) return abgeschlossen.value ? 'Keine Tore' : 'Noch keine Tore'
  const zusatz = (t) => t.art === 'elfmeter' ? ' (Elfmeter)' : t.art === 'eigentor' ? ' (Eigentor)' : ''
  const text = e.map(t => `${t.minute != null ? t.minute + (t.extra > 0 ? '+' + t.extra : '') + "' " : ''}${t.spieler ? t.spieler + zusatz(t) + ' · ' : ''}${t.heim} ${t.heimtore}:${t.austore} ${t.auswaerts}`).join('   |   ')
  return text
})

// Lauftext: nur wenn der Text breiter ist als die Zeile. Geschwindigkeit in Bildschirmhöhen pro Sekunde (wie alle Maße hier in vh).
const tickerFenster = ref(null)
const tickerText1 = ref(null)
const tickerLauf = ref(false)
const tickerDauer = ref(60)
function tickerMessen() {
  nextTick(() => {
    const f = tickerFenster.value, t = tickerText1.value
    if (!f || !t) return
    const breite = t.offsetWidth
    tickerLauf.value = breite > f.clientWidth
    const pxProSek = Math.max(40, window.innerHeight * 0.12)
    tickerDauer.value = Math.max(20, Math.round((breite + window.innerHeight * 0.06) / pxProSek))
  })
}
watch(tickerText, tickerMessen, { flush: 'post' })

// ---------- Kopf ----------
const badgeText = computed(() => anzahlLaufend.value > 0 ? 'LIVE' : (abgeschlossen.value ? 'ENDSTAND' : ''))
const rundenTitel = computed(() => props.rundenName || tvRundeName.value || (rid.value > 0 ? 'Runde' : 'Gesamtliga'))
// QR-Code als SVG-Pfad (kein externer Dienst, Fehlerkorrektur M); Rand (quiet zone) 4 Module
const qr = computed(() => {
  const u = String(props.qrUrl ?? '').trim()
  if (!u) return null
  try {
    const q = qrcode(0, 'M'); q.addData(u); q.make()
    const n = q.getModuleCount(), rand = 4; let d = ''
    for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (q.isDark(r, c)) d += `M${c + rand} ${r + rand}h1v1h-1z`
    return { d, size: n + rand * 2 }
  } catch (e) { return null }
})
const sponsorListe = computed(() => String(props.sponsoren ?? '').split(',').map(x => x.trim()).filter(Boolean).slice(0, 7))
// Stand: Zeitpunkt der letzten Socket-Nachricht; verbunden = Nachricht in den letzten 60 s (Vermutung: der Server sendet laufend, mind. Pong)
const letzteNachricht = ref(0)
const jetzt = ref(Date.now())
const verbunden = computed(() => props.demo || (letzteNachricht.value > 0 && jetzt.value - letzteNachricht.value < 60000))
const endstandText = computed(() => restStand.value ? new Date(restStand.value).toLocaleString('de-AT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '')
const standText = computed(() => letzteNachricht.value ? new Date(letzteNachricht.value).toLocaleTimeString('de-AT') : '')
const merkeNachricht = () => { letzteNachricht.value = Date.now() }
let uhr = null
const uhrText = computed(() => new Date(jetzt.value).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' }))

onMounted(() => {
  tickerMessen()
  window.addEventListener('resize', tickerMessen)
  uhr = setInterval(() => { jetzt.value = Date.now() }, 1000)
  window.addEventListener('tm-live-scores', merkeNachricht)
  ladeTvRunde()
  tvTimer = setInterval(ladeTvRunde, 30000)
  ladenPerRest()
  restTimer = setInterval(ladenPerRest, 30000)
  if (!props.demo && props.wsUrl) {
    verbinden()
    if (rid.value > 0) meldeRunde(rid.value)
  }
})
onUnmounted(() => {
  window.removeEventListener('resize', tickerMessen)
  clearInterval(uhr)
  clearInterval(restTimer)
  clearInterval(tvTimer)
  window.removeEventListener('tm-live-scores', merkeNachricht)
  if (typeof aufraeumen === 'function') aufraeumen()
})
watch(rid, (neu) => {
  restEintraege.value = []
  restMatchIds.value = []
  restSpiele.value = []
  abgeschlossen.value = false
  restStand.value = 0
  matchIdsGeprueft = false
  for (const k of Object.keys(rangMerker)) delete rangMerker[k]
  for (const k of Object.keys(vorherRang)) delete vorherRang[k]
  for (const k of Object.keys(torStand)) delete torStand[k]
  for (const k of Object.keys(torMerker)) delete torMerker[k]
  ladenPerRest()
  if (!props.demo && props.wsUrl && neu > 0) meldeRunde(neu)
})
</script>

<style scoped>
:host { display: block; background: #0a0f1e; }
.tv { height: 100vh; max-width: calc(100vh * 1.78); margin: 0 auto; overflow: hidden; box-sizing: border-box; padding: 2vh 2.2vw; display: flex; flex-direction: column; gap: 1.6vh;
      background: #0a0f1e; color: #f1f4fa; font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif; }
.tv-kopf { flex: none; display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; }
.tv-mitte { min-height: 1px; }
.tv-rechts { display: flex; align-items: center; justify-content: flex-end; gap: 2.4vh; }
.tv-titel { text-align: right; line-height: 1.1; }
.tv-titel b { display: block; font-size: 3.2vh; color: #ffc233; }
.tv-titel span { font-size: 2.2vh; opacity: .85; }
.tv-logo { font-size: 3vh; font-weight: 800; }
.tv-lokal__logo { height: 7vh; max-width: 30vw; object-fit: contain; display: block; }
.tv-lokal__name { font-size: 4.6vh; font-weight: 900; line-height: 1.05; }
.tv-runde { display: flex; align-items: center; gap: 1vh; padding: 1vh 2.2vh; border-radius: 99px; background: #131a30; font-weight: 800; font-size: 2.6vh; letter-spacing: .03em; text-transform: uppercase; }
.tv-punkt { width: 1.2vh; height: 1.2vh; border-radius: 50%; background: #ff6b81; }
.tv-qr { display: flex; flex-direction: column; align-items: center; gap: .5vh; }
.tv-qr svg { display: block; background: #fff; border-radius: .8vh; }
.tv-qr span { font-size: 1.4vh; font-weight: 700; opacity: .85; letter-spacing: .04em; text-transform: uppercase; }
.tv-qr--kopf { flex-direction: row; gap: 1.2vh; }
.tv-qr--kopf span { max-width: 11vh; text-align: right; line-height: 1.15; font-size: 1.6vh; }
.tv-qr--kopf svg { height: 8.5vh; width: 8.5vh; }
.tv-qr--gross { margin-top: 3vh; }
.tv-qr--gross svg { height: 24vh; width: 24vh; }
.tv-qr--gross span { font-size: 2.2vh; }
.tv-uhr { text-align: right; }
.tv-uhr__zeit { font-size: 4vh; font-weight: 800; line-height: 1; }
.tv-uhr__lokal { font-size: 1.5vh; opacity: .7; }
.tv-verbindung { display: inline-block; width: .9vh; height: .9vh; border-radius: 50%; background: #3ddc97; margin-right: .6vh; }
.tv-verbindung.aus { background: #ff6b81; }

.tv-haupt { flex: 1; min-height: 0; display: grid; grid-template-columns: 1.1fr 1fr; grid-template-rows: minmax(0, 1fr); gap: 1.8vw; }
.tv-links { display: flex; flex-direction: column; gap: 1.6vh; min-height: 0; }
.tv-rang, .tv-spiele, .tv-sponsoren { background: #121a31; border-radius: 1.6vh; padding: 1.4vh 1.4vw; min-height: 0; overflow: hidden; }
.tv-rang { flex: 1; display: flex; flex-direction: column; }
.tv-rang__liste { flex: none; display: flex; flex-direction: column; gap: .3vh; }
.tv-rang__titel, .tv-spiele__titel { flex: none; font-size: 2.2vh; font-weight: 800; text-transform: uppercase; letter-spacing: .02em; margin-bottom: .6vh; }
.tv-rang__spalten, .tv-zeile { display: grid; grid-template-columns: 5vh 8vh 1fr 12vh 14vh; align-items: center; column-gap: 1vw; }
.tv-rang__spalten { flex: none; font-size: 1.4vh; opacity: .55; padding: 0 1vh .5vh; }
.tv-rang__spalten.ohne-heute, .tv-zeile.ohne-heute { grid-template-columns: 5vh 8vh 1fr 12vh; }
.tv-rang__spalten.ohne-bew, .tv-zeile.ohne-bew { grid-template-columns: 5vh 1fr 12vh 14vh; }
.tv-rang__spalten.ohne-bew.ohne-heute, .tv-zeile.ohne-bew.ohne-heute { grid-template-columns: 5vh 1fr 14vh; }
.r { text-align: right; justify-self: end; }
.tv-zeile { height: 5.4vh; padding: 0 1vh; border-radius: .8vh; font-size: 2.8vh; }
.tv-zeile:nth-child(-n+3) { background: #1b2646; }
.tv-platz { font-weight: 800; font-size: 3vh; }
.tv-bew { font-size: 2vh; font-weight: 700; opacity: .85; }
.tv-bew.auf { color: #3ddc97; }
.tv-bew.ab { color: #ff6b81; }
.tv-name { position: relative; z-index: 0; height: 100%; display: flex; align-items: center; gap: 1vh; white-space: nowrap; overflow: hidden; }
/* Balken hinter dem Namen: Länge = Punkte im Verhältnis zum Ersten */
.tv-balken { position: absolute; left: 0; top: 16%; bottom: 16%; z-index: -1; border-radius: .6vh; background: linear-gradient(90deg, rgba(61,220,151,.30), rgba(61,220,151,.06)); transition: width .6s ease; }
.tv-geteilt { flex: none; padding: .3vh 1vh; border-radius: 99px; background: #3a3216; color: #ffc233; font-size: 1.7vh; font-weight: 700; vertical-align: middle; }
.tv-heute { font-size: 2.2vh; opacity: .7; font-variant-numeric: tabular-nums; }
.tv-heute.plus { color: #3ddc97; opacity: 1; }
.tv-punkte { font-weight: 800; font-size: 3vh; font-variant-numeric: tabular-nums; }

/* Sponsorleiste: durchgehend unten, weiß */
.tv-sponsorleiste { flex: none; height: 8.5vh; margin: 0 -2.2vw -2vh; background: #fff; display: flex; align-items: center; justify-content: space-around; padding: 0 2vw; }
.tv-sponsor { flex: none; height: 5.6vh; width: 14vw; }
.tv-sponsor img { display: block; width: 100%; height: 100%; object-fit: contain; }   /* feste Box: große Originale (z. B. 1000 px hoch) können die Leiste nicht mehr sprengen */

/* Spiele */
.tv-spiele { display: flex; flex-direction: column; }
.tv-spiele__liste { flex: none; display: flex; flex-direction: column; gap: .4vh; }
.tv-spiele__liste.zweispaltig { display: grid; grid-template-columns: 1fr 1fr; column-gap: 1vw; align-content: start; }
.tv-spiele__liste.zweispaltig .tv-grp { grid-column: 1 / -1; }
.tv-grp { flex: none; display: flex; align-items: center; gap: 1vh; font-size: 1.4vh; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; opacity: .7; padding: .6vh .4vw 0; }
.tv-grp::after { content: ""; flex: 1; height: 1px; background: rgba(255,255,255,.14); }
.tv-spiel { height: 5.2vh; display: grid; grid-template-columns: 9vh 1fr 11vh 1fr; align-items: center; background: #1b2646; border-radius: 1.2vh; padding: 0 1.2vh; border-left: .4vh solid transparent; min-width: 0; }
.tv-spiel.fertig { background: #151d38; opacity: .72; }
.tv-spiel.hat-tor { border-left-color: #ffc233; background: #233056; }
.tv-spiel__zeit { color: #ff6b81; font-weight: 800; font-size: 1.8vh; line-height: 1.15; }
.tv-spiel.fertig .tv-spiel__zeit { color: #9aa4bb; }
.tv-tor-pille { display: inline-block; margin-left: .8vh; padding: .1vh .7vh; border-radius: 99px; background: #ffc233; color: #1a1a1a; font-size: 1.3vh; font-weight: 900; letter-spacing: .06em; }
.tv-seite { display: flex; align-items: center; gap: 1vh; font-size: 2.1vh; min-width: 0; padding: .5vh .8vh; border-radius: .8vh; }
.tv-seite.heim { justify-content: flex-end; }
.tv-seite.heim .tv-spiel__name { text-align: right; }
.tv-spiel__name { flex: 1; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tv-seite.tor { background: rgba(255,194,51,.16); animation: tv-puls 1.6s ease-in-out infinite; color: #ffc233; }
.tv-erg { display: flex; align-items: center; justify-content: center; gap: .6vh; font-size: 2.8vh; font-weight: 800; font-variant-numeric: tabular-nums; }
.tv-erg i { font-style: normal; opacity: .5; font-weight: 400; }
.tv-erg b.tor { color: #ffc233; text-shadow: 0 0 1.4vh rgba(255,194,51,.7); }
@keyframes tv-puls { 50% { background: rgba(255,194,51,.32); } }
.tv-logo-team { width: 2.4vh; height: 2.4vh; object-fit: contain; flex: none; }
.tv-logo-team--ersatz { display: grid; place-items: center; border-radius: 50%; background: #2a3556; border: 1px solid rgba(255,255,255,.18); font-size: 1.2vh; font-weight: 700; color: #aab3c8; }

.tv-leer { opacity: .6; padding: 2vh 1vh; font-size: 2.2vh; }
.tv-countdown { text-align: center; padding: 8vh 2vh; }
.tv-countdown__label { font-size: 2.6vh; opacity: .7; text-transform: uppercase; letter-spacing: .2vh; }
.tv-countdown__zahl { font-size: 9vh; font-weight: 800; font-variant-numeric: tabular-nums; line-height: 1.15; margin: 1.5vh 0; color: #ffc233; }
.tv-countdown__sub { font-size: 2.6vh; opacity: .8; }
.tv-fuss { flex: none; display: flex; align-items: center; gap: 2vh; padding: 1.2vh 2vh; border-radius: 1.6vh; background: #121a31; font-size: 2.4vh; }
.tv-ticker__marke { flex: none; background: #ffc233; color: #1a1a1a; font-weight: 800; padding: .5vh 1.6vh; border-radius: 1vh; font-size: 1.9vh; }
.tv-ticker__fenster { flex: 1; min-width: 0; overflow: hidden; white-space: nowrap; }
.tv-ticker__bahn { display: inline-flex; will-change: transform; }
.tv-ticker__text { flex: none; white-space: nowrap; padding-right: 6vh; }
.tv-ticker__bahn.lauf { animation: tv-lauf linear infinite; }
@keyframes tv-lauf { to { transform: translateX(-50%); } }
/* Hochformat (Fernseher gedreht): Rangliste oben, Spiele darunter. Ungetestet. */
@media (max-aspect-ratio: 1/1) {
  .tv-haupt { grid-template-columns: 1fr; grid-template-rows: 3fr 2fr; }
}
</style>